var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkspaceLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#5B5FC7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 22,
    fontFamily: "Arial, sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#fff",
    textAnchor: "middle"
  }, "WS")));
}
export default SvgWorkspaceLogo;